import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCornerRightDownLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "corner right down",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.0283 10.6093C15.3212 10.3164 15.796 10.3164 16.0889 10.6093L19.5317 14.0521C19.8246 14.345 19.8246 14.8199 19.5317 15.1128L16.0889 18.5556C15.796 18.8485 15.3212 18.8485 15.0283 18.5556C14.7354 18.2627 14.7354 17.7879 15.0283 17.495L17.9408 14.5825L15.0283 11.67C14.7354 11.3771 14.7354 10.9022 15.0283 10.6093Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 5.22656C5.41421 5.22656 5.75 5.56235 5.75 5.97656V8.95733C5.75 11.6491 7.93285 13.8321 10.6258 13.8321H18.8013C19.2156 13.8321 19.5513 14.1679 19.5513 14.5821C19.5513 14.9963 19.2156 15.3321 18.8013 15.3321H10.6258C7.10459 15.3321 4.25 12.4777 4.25 8.95733V5.97656C4.25 5.56235 4.58579 5.22656 5 5.22656Z",
		fill: "currentColor"
	})]
});
export default SvgCornerRightDownLine;
